const FILLED_STAR = '\u2605\uFE0E';
const EMPTY_STAR = '\u2606\uFE0E';

export const renderStars = (rating: number): string => {
  const clamped = Math.max(0, Math.min(5, rating));
  const full = Math.floor(clamped);
  const half = clamped - full >= 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  return FILLED_STAR.repeat(full) + (half ? FILLED_STAR : '') + EMPTY_STAR.repeat(empty);
};
